import React from 'react'
import BtnIcon from './BtnIcon'
import { ReactSVG } from 'react-svg'
import { observer } from 'mobx-react-lite'

interface IProps {
  name?: string,
  size?: number,
  type?: string,
  onClick?: () => void,
  hideRemove?: boolean,
  children?: React.ReactNode,
}

const FilePreview = observer((props: IProps) => {
  return (
    <div className={'image-upload'}>
      <div className={'image-upload__wrapper'}>
        <div className={'image-upload__container'}>
          <div className={'image-upload__content'}>
            <div className={'image-upload__container'}>
              <div className={'image-upload__image'}>
                <img src={`/i/${props.type}.svg`} alt={'image'} className={'image-upload__icon'}/>
              </div>
            </div>
            <div
              className={'image-upload__fileinfo'}
              style={{ flexBasis: '100%' }}
            >
              <p>{props.name}</p>
              <div className="u-flex ">
                <p className={'image-upload__filesize'}>
                  {props.type}&nbsp;
                </p>
                <p className={'image-upload__filesize'}>
                  {props.size
                    ? `${Math.round(props.size / 1024)} KB`
                    : 'Нет данных'}
                </p>
              </div>
            </div>

            {!props.hideRemove && props.onClick && (
              <div className="u-flex">
                <BtnIcon
                  className="card-head__control _right-side"
                  onClick={props.onClick}
                >
                <ReactSVG src={'/i/svg/x.svg'} wrapper={'span'}/>
                </BtnIcon>
              </div>
            )}
          </div>
        </div>
        {props.children}
      </div>
    </div>
  )
})

export default FilePreview
